module.exports = [
  require('./lesson1'),
  require('./lesson2'),
  require('./lesson3')
]



// WEBPACK FOOTER //
// ./src/lessons/index.js